import React from 'react'

export default function BlobYellow() {
    return (
        <svg className="blob--yellow" xmlns="http://www.w3.org/2000/svg" width="369" height="379" viewBox="0 0 369 379" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M99.4095 263.395C71.1213 232.851 33.3179 203.782 37.1728 162.307C41.4394 116.401 75.8541 76.6412 118.419 58.8671C158.797 42.0063 206.035 51.7442 241.822 76.8506C271.947 97.9859 272.823 138.124 282.141 173.729C292.17 212.051 318.521 252.811 296.501 285.779C273.539 320.159 224.991 325.432 183.931 320.768C148.318 316.723 123.751 289.677 99.4095 263.395Z" fill="#FFFAD1"/>
        </svg>
    )
}